var map = {
	"./01-04-2026-paper-mobilenet-notes.md": 845,
	"./01-11-2025-SAE-research-draft.md": 1347,
	"./07-05-2026-bep-research-4.md": 9288,
	"./08-10-2025-ml-research-2.md": 5900,
	"./14-10-2025-ml-research-3.md": 9266,
	"./18-03-2026-bep-research-1.md": 3581,
	"./2025-09-27-automatic-code-quality-checks.md": 5256,
	"./29-03-2026-bep-research-2.md": 5764,
	"./30-04-2026-bep-research-3.md": 6620,
	"./30-09-2025-ml-research-1.md": 7296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 653;